<template>
  <section>
    <div style="display: none1">
      <el-form ref="form" label-width="80px" @submit.prevent="onSubmit"
        style="margin: 20px; width: 60%; min-width: 600px">
        <el-form-item label="内容">
          <el-input v-model="filters.content" placeholder="内容"></el-input>
        </el-form-item>

        <el-form-item label="时间">
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
      </el-form>

    </div>

    <!--列表-->
    <el-table :data="dmList" highlight-current-row v-loading="listLoading" style="width: 100%" border show-summary>
      <el-table-column prop="LoginName" label="操作人"></el-table-column>
      <el-table-column prop="Description" label="操作内容"></el-table-column>
      <el-table-column prop="LogTime" label="操作时间 "></el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getLogs, BaseApiUrl } from "../../api/api";
import * as signalR from "@aspnet/signalr";

export default {
  data() {
    return {
      filters: {
        startTime: "",
        endTime: "",

        content: "",
        page: 1,
        intPageSize: 20,
      },
      listLoading: true,
      dmList: [],
      total: 0,
    };
  },
  methods: {

    handleCurrentChange(val) {
      this.filters.page = val;
      this.getData();
    },    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getData(1);
    },
    //获取用户列表
    getData(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      getLogs(para).then((res) => {
        if (res && res.data && res.data.response && res.data.response.data) {
          this.dmList = res.data.response.data;
          this.total = res.data.response.dataCount;
        }
        this.listLoading = false;
        // thisvue.connection.start().then(() => {
        //   thisvue.connection.invoke("GetLatestCount", 1).catch((err) => {
        //     return console.error(err);
        //   });

        //   // transactionConnection.invoke('JoinGroup', 'ClientAccountTransaction').catch(err => console.error(err.toString()));
        // });
      });
    },
    submitCard() {
      // if (this.userName && this.userMessage) {
      //   this.connection
      //     .invoke("SendMessage", this.userName, this.userMessage)
      //     .catch((err) => {
      //       return console.error(err);
      //     });
      // }
    },
    getLogs() {
      // this.listLoading = true;
      // this.connection.invoke("GetLatestCount", 1).catch((err) => {
      //   return console.error(err);
      // });
    },
  },
  created() {
    // let thisVue = this;

    // thisVue.connection = new signalR.HubConnectionBuilder()
    //   .withUrl(`${BaseApiUrl}/api2/chatHub`)
    //   .configureLogging(signalR.LogLevel.Information)
    //   .build();

    // thisVue.connection.on("ReceiveMessage", (user, message) => {
    //   thisVue.messages.push({ user, message });
    // });

    // thisVue.connection.on("ReceiveUpdate", (update) => {
    //   console.info("update success!");
    //   thisVue.listLoading = false;
    //   thisVue.tableData = update;
    //   window.clearInterval(this.t);
    // });
  },
  mounted() {
    this.getData();

    //  this.t =  setTimeout(() => {
    //      this.getLogs();
    // }, 1000);
  },
  beforeDestroy() {
    // window.clearInterval(this.t);
    // this.connection.stop();
  },
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
}

.EXC {
  color: red;
}
</style>
